export default __webpack_public_path__ + "static/media/gw200.4100e640.png";